export default "__VITE_ASSET__ZXvFLjSt__"